import { createAsyncThunk } from '@reduxjs/toolkit';
import { ResponseErrorWithHandled, ResponseSuccess } from '../../shared/types';
import {
  AddEmailFromCSVRequestPayload,
  GetUploadedFilePayload,
  VerifyEmailRequestPayload,
  DownloadEmailVerifiedFilePayload,
} from './types';
import {
  getUploadedFileByCsv,
  downloadEmailVerifiedFile,
  emailVerifierUploadedFilesList,
  verifyEmail,
  getVerifiedEmailFileDetailsById,
} from './helper/email-verifier.api';

export const getVerifyEmailRequest = createAsyncThunk<
  ResponseSuccess,
  VerifyEmailRequestPayload,
  { rejectValue: ResponseErrorWithHandled }
>('email-verifier/getVerifyEmailRequest', async (payload, thunkAPI) => {
  try {
    return await verifyEmail(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const emailVerifierUploadedFilesListRequest = createAsyncThunk<
  ResponseSuccess,
  GetUploadedFilePayload,
  { rejectValue: ResponseErrorWithHandled }
>('email-verifier/emailVerifierUploadedFilesList', async (payload, thunkAPI) => {
  try {
    return await emailVerifierUploadedFilesList(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const uploadedFileCsvRequest = createAsyncThunk<
  ResponseSuccess,
  AddEmailFromCSVRequestPayload,
  { rejectValue: ResponseErrorWithHandled }
>('email-verifier/uploadedFileCsvRequest', async (payload, thunkAPI) => {
  try {
    return await getUploadedFileByCsv(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});
export const downloadEmailVerifiedFileRequest = createAsyncThunk<
  ResponseSuccess,
  DownloadEmailVerifiedFilePayload,
  { rejectValue: ResponseErrorWithHandled }
>(
  'email-verifier/downloadEmailVerifiedFileRequest',
  async (payload, thunkAPI) => {
    try {
      return await downloadEmailVerifiedFile(payload);
    } catch (e) {
      return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
    }
  },
);


export const getVerifiedEmailFileDetailsByIdRequest = createAsyncThunk<
  ResponseSuccess,
  number,
  { rejectValue: ResponseErrorWithHandled }
>('email-verifier/getVerifiedEmailFileDetailsByIdRequest', async (id, thunkAPI) => {
  try {
    return await getVerifiedEmailFileDetailsById(id);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});